import React from 'react';

export const CleansesIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.24215 10.4959L7.9134 14.7965C8.53563 15.3693 9.293 15.775 10.1147 15.9755L18.382 17.9928C20.7972 18.5822 22.9064 20.0501 24.298 22.1102L28.2441 27.952M1.93075 19.0821L7.74705 23.4785C8.05734 23.7131 8.41027 23.885 8.78621 23.9848L20.5937 27.1198C21.1927 27.2788 21.7344 26.7202 21.5571 26.1264V26.1264C21.1673 24.8214 20.1351 23.8078 18.8232 23.4418L12.6289 21.7138"
      stroke="url(#paint0_linear)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 1C9.06095 2.16284 9.53234 4.00751 10.7349 5.87302M10.7349 5.87302C12.0681 7.94112 14.3 10.0348 17.8675 11.2536M10.7349 5.87302C10.4137 7.22075 10.5807 10.5849 13.8193 13.2598V11.2536L15.9398 14.5604C17.3421 15.1997 18.9031 15.5774 20.3735 15.7843M10.7349 5.87302C15.6699 4.77837 19.988 8.11237 21.5301 9.91621L19.988 11.2536H22.6867L25 15.9347C23.9334 16.0347 22.2253 16.0449 20.3735 15.7843M20.3735 15.7843C20.0522 15.4629 19.4096 14.5972 19.4096 13.7056"
      stroke="url(#paint1_linear)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="8.07167"
        y1="23.4654"
        x2="27.6018"
        y2="14.1672"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="21.3365"
        y1="11.6004"
        x2="8.18498"
        y2="7.37553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
